import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ref, onValue } from 'firebase/database';
import { database } from '../../firebaseConfig';
import { OUTREACH_KINDS, tallyOutreach } from '../../services/outreach';
import LogAppointmentModal from './LogAppointmentModal';

// My Outreach: personal Calls, Texts, Emails and Appointments set (today / this week / this month).
// Optional weekly goals come from system/outreachGoals { call, text, email, appointment } (admin-set; none yet).
const card = { background: '#fff', border: '1px solid #e5e5e5', borderRadius: 10, padding: 16, marginBottom: 16, maxWidth: '100%', boxSizing: 'border-box' };
const grid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 8 };
const tile = { background: '#faf7ef', borderRadius: 8, padding: 10, minWidth: 0 };
const btn = { padding: '8px 12px', fontSize: 14, border: '1px solid #b8903a', background: '#d9b357', borderRadius: 6, fontWeight: 700, cursor: 'pointer' };
const PERIODS = [['today', 'Today'], ['week', 'This week'], ['month', 'This month']];

const useGoals = () => {
  const [g, setG] = useState({});
  useEffect(() => onValue(ref(database, 'system/outreachGoals'), (s) => setG(s.val() || {}), () => setG({})), []);
  return g;
};

export function OutreachCard({ uid, full = false }) {
  const [entries, setEntries] = useState({});
  const [logOpen, setLogOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const goals = useGoals();
  useEffect(() => (uid ? onValue(ref(database, `users/${uid}/outreach`), (s) => setEntries(s.val() || {}), () => setEntries({})) : undefined), [uid]);
  const t = tallyOutreach(entries);
  return (
    <div style={card}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
        <strong style={{ fontSize: 16 }}>My Outreach</strong>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button type="button" style={btn} onClick={() => { setMsg(''); setLogOpen(true); }}>Log appointment</button>
          {!full && <Link to="/performance" style={{ fontSize: 14, alignSelf: 'center' }}>Details</Link>}
        </div>
      </div>
      {full ? PERIODS.map(([p, label]) => (
        <div key={p} style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 13, color: '#666', fontWeight: 600, marginBottom: 4 }}>{label}</div>
          <div style={grid}>{OUTREACH_KINDS.map((k) => <Tile key={k.key} label={k.label} n={t[k.key][p]} goal={p === 'week' ? goals[k.key] : null} />)}</div>
        </div>
      )) : (
        <div style={grid}>{OUTREACH_KINDS.map((k) => <Tile key={k.key} label={k.label} n={t[k.key].today} sub={`${t[k.key].week} this week`} goal={null} />)}</div>
      )}
      {!full && <div style={{ fontSize: 12, color: '#777', marginTop: 6 }}>Today, with this week underneath.</div>}
      {msg && <div style={{ fontSize: 13, color: '#2e7d32', marginTop: 6 }}>{msg}</div>}
      {logOpen && <LogAppointmentModal uid={uid} onDone={(ok) => { setLogOpen(false); if (ok) setMsg('Appointment logged.'); }} />}
    </div>
  );
}

function Tile({ label, n, sub, goal }) {
  const g = Number(goal) > 0 ? Number(goal) : null;
  return (
    <div style={tile}>
      <div style={{ fontSize: 12, color: '#666' }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 800 }}>{n}{g ? <span style={{ fontSize: 13, fontWeight: 600, color: n >= g ? '#2e7d32' : '#777' }}> / {g}</span> : null}</div>
      {sub && <div style={{ fontSize: 12, color: '#777' }}>{sub}</div>}
    </div>
  );
}

// Admin: every agent side by side. users/* is readable by any signed-in user; this is only rendered for admins.
export function OutreachTeamTable() {
  const [users, setUsers] = useState({});
  const [period, setPeriod] = useState('week');
  useEffect(() => onValue(ref(database, 'users'), (s) => setUsers(s.val() || {}), () => setUsers({})), []);
  const rows = Object.entries(users)
    .filter(([, u]) => u && typeof u === 'object' && !['TC', 'Marketing Manager', 'Local Assistant'].includes(u.role))
    .map(([uid, u]) => ({ uid, name: u.displayName || [u.profile?.firstName, u.profile?.lastName].filter(Boolean).join(' ') || u.email || 'Team member', t: tallyOutreach(u.outreach) }))
    .sort((a, b) => a.name.localeCompare(b.name));
  const th = { textAlign: 'right', padding: '6px 4px', fontSize: 12, color: '#8C6D1F' };
  const td = { textAlign: 'right', padding: '6px 4px', fontSize: 14, borderTop: '1px solid #eee' };
  return (
    <div style={card}>
      <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
        <strong style={{ fontSize: 16 }}>Team outreach</strong>
        <select value={period} onChange={(e) => setPeriod(e.target.value)} style={{ fontSize: 16, padding: 4 }}>{PERIODS.map(([p, l]) => <option key={p} value={p}>{l}</option>)}</select>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr><th style={{ ...th, textAlign: 'left' }}>Agent</th><th style={th}>Calls</th><th style={th}>Texts</th><th style={th}>Emails</th><th style={th}>Appts</th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.uid}><td style={{ ...td, textAlign: 'left' }}>{r.name}</td>{OUTREACH_KINDS.map((k) => <td key={k.key} style={td}>{r.t[k.key][period]}</td>)}</tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
